var _rect, _rect2, _text, _text2, _text3, _line, _line2, _path, _path2, _circle, _text4, _line3, _text5, _rect3, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionFluctuation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluctuationGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a3d4d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a5f6f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#fluctuationGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 300,
    height: 180,
    rx: 8,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 55,
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.6
  }, "HIGH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 120,
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.6
  }, "NORMAL")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 195,
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.6
  }, "LOW")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 100,
    x2: 350,
    y2: 100,
    stroke: "#00ffff",
    strokeWidth: 0.5,
    opacity: 0.2,
    strokeDasharray: "2,2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 150,
    x2: 350,
    y2: 150,
    stroke: "#00ffff",
    strokeWidth: 0.5,
    opacity: 0.2,
    strokeDasharray: "2,2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 140 Q 90 120 120 140 T 180 140 T 240 140 T 300 140 T 340 140",
    stroke: "#00ff88",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 140 L 215 70 L 230 140",
    stroke: "#ff6b6b",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 70,
    r: 12,
    fill: "#ff6b6b",
    opacity: 0.8
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 76,
    textAnchor: "middle",
    fontSize: 14,
    fill: "white",
    fontWeight: "bold"
  }, "!")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 70,
    x2: 250,
    y2: 30,
    stroke: "#ff6b6b",
    strokeWidth: 1.5,
    opacity: 0.7
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 40,
    fontSize: 10,
    fill: "#ff6b6b",
    fontWeight: "bold"
  }, "ANOMALY DETECTED")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 230,
    width: 300,
    height: 50,
    rx: 5,
    fill: "#00ffff",
    opacity: 0.08,
    stroke: "#00ffff",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 245)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 9,
    fill: "#00ffff",
    fontWeight: "bold"
  }, "Detection Time"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 15,
    fontSize: 11,
    fill: "#00ff88"
  }, "90% Accuracy"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190, 245)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 9,
    fill: "#00ffff",
    fontWeight: "bold"
  }, "Downtime Prediction"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 15,
    fontSize: 11,
    fill: "#00ff88"
  }, "95% Proactive"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 245)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 9,
    fill: "#00ffff",
    fontWeight: "bold"
  }, "False Positive Rate"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 15,
    fontSize: 11,
    fill: "#00ff88"
  }, "&lt;5%"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFluctuation);
export default __webpack_public_path__ + "static/media/transaction_fluctuation.364a12cc1e0171c533fabfda7c6a8dc1.svg";
export { ForwardRef as ReactComponent };